<script setup lang="ts">
import type { WarningCalendarSummaryViewCalendarSummaryFragment } from './WarningCalendarSummaryView.generated'
import StateChip from '@/components/atoms/StateChip.vue'
import { statusString, statusVariation } from '../calendar'
import { useRoute } from 'vue-router'
import type { CalendarWarning } from './type'

const route = useRoute('calendarSetting')

const { warningCalendarSummary: summary, warning } = defineProps<{
  warningCalendarSummary: WarningCalendarSummaryViewCalendarSummaryFragment
  warning: CalendarWarning
}>()
</script>

<template>
  <router-link
    :class="$style.warningSummary"
    :to="{
      name: 'calendarSettingDetail',
      params: {
        entranceGUID: route.params.entranceGUID,
        calendarGUID: summary.guid,
      },
    }"
  >
    <div :class="$style.warningSummary__chip">
      <StateChip
        :text="statusString(summary.status)"
        :variation="statusVariation(summary.status)"
      />
    </div>
    <div :class="$style.warningSummary__content">
      <div :class="$style.warningSummary__title">
        {{ summary.privateTitle || summary.publicTitle }}
      </div>
      <div v-if="summary.privateTitle" :class="$style.warningSummary__subTitle">
        {{ summary.publicTitle }}
      </div>
      <div :class="$style.warningSummary__warning">
        <template v-if="warning === 'STAFF_NOT_ASSIGNED'">
          担当者が設定されていません
        </template>
        <template v-if="warning === 'NOT_LINKED'">
          一部担当者にアカウント再連携が必要です
        </template>
      </div>
    </div>
  </router-link>
</template>

<style lang="scss" module>
.warningSummary {
  display: flex;
  padding: 4px;
  gap: 8px;
  border: 1px solid $color-border-low-emphasis;
  border-radius: $border-radius-v2-base;
  width: 100%;
  background-color: $color-surface-accent-red;
  color: $color-text-and-object-high-emphasis-inverse;

  &:hover {
    text-decoration: none;
    border-color: $color-surface-accent-primary-light;
  }

  &__chip {
    display: flex;
    flex-direction: column;
    min-width: 72px;
    align-items: center;
    justify-content: center;
  }

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__title {
    color: $color-text-and-object-accent-primary;
    font-weight: bold;
    font-size: 16px;
  }

  &__subTitle {
    color: $color-text-and-object-high-emphasis-inverse;
    font-size: 14px;
  }

  &__warning {
    color: $color-text-and-object-high-emphasis-inverse;
    font-size: 14px;
  }
}
</style>
